/* src/utils/admin.js
 * Admin access control utilities
 */

const PRIMARY_ADMIN_EMAIL = 'donnie@goodatmarketing.com';

/**
 * Check if user is an admin
 * @param {Object} user - Firebase auth user object
 * @param {Object} userProfile - User profile from Firestore
 * @returns {boolean}
 */
export function isAdmin(user, userProfile) {
  if (!user || !user.email) {
    return false;
  }

  // Primary admin (donnie@goodatmarketing.com)
  if (user.email.toLowerCase() === PRIMARY_ADMIN_EMAIL.toLowerCase()) {
    return true;
  }

  // Check if user has isAdmin flag in profile
  if (userProfile?.isAdmin === true) {
    return true;
  }

  return false;
}

/**
 * Check if user can access admin features
 * @param {Object} user - Firebase auth user object
 * @param {Object} userProfile - User profile from Firestore
 * @returns {Promise<boolean>}
 */
export async function canAccessAdmin(user, userProfile) {
  return isAdmin(user, userProfile);
}
